// move reco panel below side nav

const moveRecoPanel = () => {
  const hubNav = document.querySelector('.hub-nav--wrapper');
  const recoPanel = document.querySelector('.reco-panel');

  if (hubNav && recoPanel) {
    hubNav.insertAdjacentElement('beforeend', recoPanel);
  }
};

module.exports = moveRecoPanel;



// WEBPACK FOOTER //
// ./scriptPartials/moveRecoPanel.js